var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleCvPassenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.178 27.6887L48.0696 20.2517C47.1042 17.9284 44.8338 16.4219 42.3195 16.4219H7.22479C4.74228 16.4219 2.72656 18.4376 2.72656 20.9201V33.8313C2.72656 34.4997 3.26762 35.0301 3.92538 35.0301H50.0747C50.7431 35.0301 51.2735 34.4891 51.2735 33.8313V28.1555C51.2735 27.9963 51.2417 27.8372 51.178 27.6887Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.178 27.6887L48.0696 20.2517C47.1042 17.9284 44.8338 16.4219 42.3195 16.4219H7.22479C4.74228 16.4219 2.72656 18.4376 2.72656 20.9201V21.7052C2.72656 19.2227 4.74228 17.2069 7.22479 17.2069H42.3089C44.8232 17.2069 47.0936 18.7134 48.059 21.0368L51.1674 28.4737C51.2311 28.6223 51.2629 28.7814 51.2629 28.9405V28.1555C51.2735 27.9963 51.2417 27.8372 51.178 27.6887Z",
    fill: "#FCFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72656 33.7051V33.8218C2.72656 34.4901 3.26762 35.0206 3.92538 35.0206H50.0747C50.7431 35.0206 51.2735 34.4795 51.2735 33.8218V33.7051H2.72656Z",
    fill: "#DEDEDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72643 29.4192H51.2734V28.1567C51.2734 27.9976 51.2416 27.8384 51.1779 27.6899L50.6687 26.4805H2.71582V29.4192H2.72643Z",
    fill: "#4B5AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6055 18.6074H12.2959V26.0019H19.6055V18.6074Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4101 18.6074H20.5288V26.0019H40.4101V18.6074Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3837 18.6074H5.432C4.8485 18.6074 4.37109 19.0848 4.37109 19.6683V24.941C4.37109 25.5245 4.8485 26.0019 5.432 26.0019H11.3837V18.6074Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4969 21.0263C46.8285 19.5622 45.3644 18.6074 43.7519 18.6074H41.333V21.0263H47.4969Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5443 26.0029L47.7513 21.6426H41.3223V26.0029H43.4441L45.7993 28.7188C45.7993 28.7188 48.2712 28.7188 49.3321 28.7188C50.393 28.7188 49.5443 26.0029 49.5443 26.0029Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6493 19.7539H28.1035V34.4899H34.6493V19.7539Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2651 20.0293H28.3794V34.2136H31.2651V20.0293Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3735 20.0293H31.4878V34.2136H34.3735V20.0293Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.425 34.4261C19.425 32.3361 17.7275 30.6387 15.6375 30.6387C13.5475 30.6387 11.8501 32.3361 11.8501 34.4261C11.8501 34.6277 11.8713 34.8292 11.9031 35.0308H19.3825C19.4037 34.8292 19.425 34.6383 19.425 34.4261Z",
    fill: "#02050C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6374 34.4261C46.6374 32.3361 44.9399 30.6387 42.8499 30.6387C40.7599 30.6387 39.0625 32.3361 39.0625 34.4261C39.0625 34.6277 39.0837 34.8292 39.1155 35.0308H46.5949C46.6161 34.8292 46.6374 34.6383 46.6374 34.4261Z",
    fill: "#02050C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.627 37.5772C17.3671 37.5772 18.7778 36.1665 18.7778 34.4263C18.7778 32.6861 17.3671 31.2754 15.627 31.2754C13.8868 31.2754 12.4761 32.6861 12.4761 34.4263C12.4761 36.1665 13.8868 37.5772 15.627 37.5772Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6271 36.2835C16.6525 36.2835 17.4837 35.4523 17.4837 34.4269C17.4837 33.4015 16.6525 32.5703 15.6271 32.5703C14.6017 32.5703 13.7705 33.4015 13.7705 34.4269C13.7705 35.4523 14.6017 36.2835 15.6271 36.2835Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.627 35.5938C16.2715 35.5938 16.7939 35.0713 16.7939 34.4268C16.7939 33.7822 16.2715 33.2598 15.627 33.2598C14.9824 33.2598 14.46 33.7822 14.46 34.4268C14.46 35.0713 14.9824 35.5938 15.627 35.5938Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6273 35.1365C16.0199 35.1365 16.3381 34.8182 16.3381 34.4257C16.3381 34.0331 16.0199 33.7148 15.6273 33.7148C15.2347 33.7148 14.9165 34.0331 14.9165 34.4257C14.9165 34.8182 15.2347 35.1365 15.6273 35.1365Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6271 33.1104C15.7501 33.1104 15.8499 33.0249 15.8499 32.9195C15.8499 32.814 15.7501 32.7285 15.6271 32.7285C15.504 32.7285 15.4043 32.814 15.4043 32.9195C15.4043 33.0249 15.504 33.1104 15.6271 33.1104Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6271 36.1339C15.7501 36.1339 15.8499 36.0484 15.8499 35.9429C15.8499 35.8374 15.7501 35.752 15.6271 35.752C15.504 35.752 15.4043 35.8374 15.4043 35.9429C15.4043 36.0484 15.504 36.1339 15.6271 36.1339Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1441 34.6487C17.2496 34.6487 17.335 34.549 17.335 34.4259C17.335 34.3029 17.2496 34.2031 17.1441 34.2031C17.0386 34.2031 16.9531 34.3029 16.9531 34.4259C16.9531 34.549 17.0386 34.6487 17.1441 34.6487Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1207 34.6487C14.2261 34.6487 14.3116 34.549 14.3116 34.4259C14.3116 34.3029 14.2261 34.2031 14.1207 34.2031C14.0152 34.2031 13.9297 34.3029 13.9297 34.4259C13.9297 34.549 14.0152 34.6487 14.1207 34.6487Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8607 33.5101C16.9353 33.4355 16.9252 33.3046 16.8382 33.2176C16.7512 33.1306 16.6202 33.1205 16.5457 33.195C16.4711 33.2696 16.4812 33.4006 16.5682 33.4876C16.6552 33.5746 16.7862 33.5847 16.8607 33.5101Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7245 35.6586C14.7991 35.584 14.789 35.453 14.702 35.366C14.615 35.279 14.484 35.2689 14.4094 35.3435C14.3349 35.4181 14.3449 35.549 14.4319 35.6361C14.519 35.7231 14.6499 35.7331 14.7245 35.6586Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5499 35.6532C16.6244 35.7278 16.7554 35.7177 16.8424 35.6307C16.9295 35.5437 16.9396 35.4128 16.865 35.3382C16.7904 35.2636 16.6594 35.2736 16.5724 35.3606C16.4854 35.4476 16.4753 35.5786 16.5499 35.6532Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4034 33.5204C14.478 33.595 14.6089 33.5849 14.696 33.4979C14.783 33.4109 14.7931 33.2799 14.7185 33.2054C14.6439 33.1308 14.513 33.1408 14.4259 33.2278C14.3389 33.3148 14.3288 33.4458 14.4034 33.5204Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8394 37.5772C44.5795 37.5772 45.9902 36.1665 45.9902 34.4263C45.9902 32.6861 44.5795 31.2754 42.8394 31.2754C41.0992 31.2754 39.6885 32.6861 39.6885 34.4263C39.6885 36.1665 41.0992 37.5772 42.8394 37.5772Z",
    fill: "#4F5565"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8395 36.2835C43.8649 36.2835 44.6961 35.4523 44.6961 34.4269C44.6961 33.4015 43.8649 32.5703 42.8395 32.5703C41.8141 32.5703 40.9829 33.4015 40.9829 34.4269C40.9829 35.4523 41.8141 36.2835 42.8395 36.2835Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8394 35.5938C43.4839 35.5938 44.0064 35.0713 44.0064 34.4268C44.0064 33.7822 43.4839 33.2598 42.8394 33.2598C42.1948 33.2598 41.6724 33.7822 41.6724 34.4268C41.6724 35.0713 42.1948 35.5938 42.8394 35.5938Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8392 35.1365C43.2318 35.1365 43.55 34.8182 43.55 34.4257C43.55 34.0331 43.2318 33.7148 42.8392 33.7148C42.4467 33.7148 42.1284 34.0331 42.1284 34.4257C42.1284 34.8182 42.4467 35.1365 42.8392 35.1365Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.839 33.1104C42.962 33.1104 43.0618 33.0249 43.0618 32.9195C43.0618 32.814 42.962 32.7285 42.839 32.7285C42.716 32.7285 42.6162 32.814 42.6162 32.9195C42.6162 33.0249 42.716 33.1104 42.839 33.1104Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.839 36.1339C42.962 36.1339 43.0618 36.0484 43.0618 35.9429C43.0618 35.8374 42.962 35.752 42.839 35.752C42.716 35.752 42.6162 35.8374 42.6162 35.9429C42.6162 36.0484 42.716 36.1339 42.839 36.1339Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.356 34.6487C44.4615 34.6487 44.547 34.549 44.547 34.4259C44.547 34.3029 44.4615 34.2031 44.356 34.2031C44.2505 34.2031 44.165 34.3029 44.165 34.4259C44.165 34.549 44.2505 34.6487 44.356 34.6487Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3326 34.6487C41.438 34.6487 41.5235 34.549 41.5235 34.4259C41.5235 34.3029 41.438 34.2031 41.3326 34.2031C41.2271 34.2031 41.1416 34.3029 41.1416 34.4259C41.1416 34.549 41.2271 34.6487 41.3326 34.6487Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0727 33.5121C44.1472 33.4375 44.1372 33.3065 44.0502 33.2195C43.9631 33.1325 43.8322 33.1224 43.7576 33.197C43.683 33.2716 43.6931 33.4026 43.7801 33.4896C43.8671 33.5766 43.9981 33.5866 44.0727 33.5121Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9286 35.6527C42.0032 35.5781 41.9931 35.4471 41.9061 35.3601C41.8191 35.2731 41.6881 35.2631 41.6135 35.3376C41.539 35.4122 41.549 35.5432 41.6361 35.6302C41.7231 35.7172 41.854 35.7273 41.9286 35.6527Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7579 35.6552C43.8324 35.7297 43.9634 35.7197 44.0505 35.6327C44.1375 35.5457 44.1476 35.4147 44.073 35.3401C43.9984 35.2655 43.8674 35.2756 43.7804 35.3626C43.6934 35.4496 43.6833 35.5806 43.7579 35.6552Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6187 33.5126C41.6933 33.5872 41.8243 33.5771 41.9113 33.4901C41.9983 33.4031 42.0084 33.2721 41.9338 33.1975C41.8593 33.123 41.7283 33.133 41.6413 33.22C41.5543 33.307 41.5442 33.438 41.6187 33.5126Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.936 20.8145H28.9097V26.7343H30.936V20.8145Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8427 20.8145H31.8164V26.7343H33.8427V20.8145Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.144 26.002L46.1385 28.3572H48.9818C48.9818 28.3572 49.491 28.1025 49.3213 27.1796C49.1515 26.2566 48.8757 26.002 48.8757 26.002H44.144Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2733 29.7695H49.8623V32.5703H51.2733V29.7695Z",
    fill: "#FBD303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6493 18.6074H28.1035V20.029H34.6493V18.6074Z",
    fill: "#393D47"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleCvPassenger);
export default __webpack_public_path__ + "static/media/Vehicle-CVPassenger.f5796f4bdcb6e5f792cd35b56ca53b7b.svg";
export { ForwardRef as ReactComponent };